import { PageType } from "@product/scmp-sdk";

import type { AppBarVariant } from "~/components/app-bar/helpers";
import type { Variant as SectionVariant } from "~/pages/section/enums";

export const pathname = "/section";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      entityId: string;
      name?: string;
      sectionVariant?: SectionVariant;
      slide: Slide;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
  slideFromSuffix(suffix?: string): Slide {
    switch (suffix) {
      case "opinion":
        return "opinion";
      case "explore":
        return "explore";
      default:
        return "main";
    }
  },
  suffix: ["explore", "opinion"] as const,
};

type Slide = "main" | "opinion" | "explore";
